
import { AppleBusinessConnectApi } from '@/api/AppleBusinessConnectApi';
import PlatformDisconnectRow from '@/components/social/PlatformDisconnectRow.vue';
import { GENERIC_ERROR_DESCRIPTION } from '@/constants';
import { BotMixin } from '@/mixins/BotMixin';
import isEqual from 'fast-deep-equal/es6';
import { AppleBusinessConnectPlatformData, SupportedPlatform } from 'ignite360-core';
import { mixins } from 'vue-class-component';
import { Component, Prop, Watch } from 'vue-property-decorator';

type AppleBusinessConnectSettings = Pick<
  AppleBusinessConnectPlatformData,
  'enablePosting' | 'companyId' | 'locationId' | 'locationName'
>;

@Component({
  name: 'apple-business-connect-settings-card',
  components: { PlatformDisconnectRow },
})
export default class AppleBusinessConnectSettingsCard extends mixins(BotMixin) {
  @Prop({ required: false, type: Boolean, default: false })
  readonly showDisconnect!: boolean;

  appleBusinessConnectSettings = this.resetValue();

  isSubmitting = false;
  isDisconnecting = false;

  get settingsHaveChanged(): boolean {
    return !isEqual(this.appleBusinessConnectSettings, this.resetValue());
  }

  async onSubmit() {
    this.isSubmitting = true;
    try {
      await this.$updateBotPlatform({
        id: this.bot.id,
        platform: SupportedPlatform.AppleBusinessConnect,
        data: this.appleBusinessConnectSettings,
      });
      this.$notify.success('Successfully updated Apple Business Connect-settings');
    } catch (e) {
      this.$notify.error({
        title: 'Updating Apple Business Connect-settings failed',
        description: GENERIC_ERROR_DESCRIPTION,
      });
    } finally {
      this.isSubmitting = false;
    }
  }

  async onDisconnect() {
    this.isDisconnecting = true;
    try {
      await AppleBusinessConnectApi.disconnectBotFromAppleBusinessConnectLocation(this.bot.id);
      this.$emit('disconnect');
      this.$notify.success('Successfully disconnected from Apple Business Connect');
    } catch (e) {
      this.$notify.error({
        title: 'Disconnecting from Apple Business Connect failed',
        description: GENERIC_ERROR_DESCRIPTION,
      });
    } finally {
      this.isDisconnecting = false;
    }
  }

  @Watch('bot', { immediate: true, deep: true })
  private reset() {
    this.appleBusinessConnectSettings = this.resetValue();
  }

  private resetValue(): AppleBusinessConnectSettings {
    return {
      enablePosting: this.bot.platformData.appleBusinessConnect?.enablePosting || false,
      companyId: this.bot.platformData.appleBusinessConnect?.companyId || '',
      locationId: this.bot.platformData.appleBusinessConnect?.locationId || '',
      locationName: this.bot.platformData.appleBusinessConnect?.locationName || '',
    };
  }
}
